import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dArray$dNonEmpty$dInternal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap from "../Data.Map/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup$dFoldable from "../Data.Semigroup.Foldable/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Restaumatic$dCoreSites$dTranslations$dKeys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dMenu$dV2$dCartToOrder from "../Restaumatic.Menu.V2.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
const forWithIndex_ = /* #__PURE__ */ Data$dFoldableWithIndex.forWithIndex_(Data$dEither.applicativeEither)(Data$dMap$dInternal.foldableWithIndexMap);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Data$dEither.applicativeEither);
const for_1 = /* #__PURE__ */ for_(Data$dFoldable.foldableMaybe);
const for_2 = /* #__PURE__ */ for_(Data$dFoldable.foldableArray);
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMap$dInternal.monoidMap(Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.ordInternalParameterId))(Data$dFoldable.identity))();
const for1_ = /* #__PURE__ */ (() => {
  const $0 = Data$dSemigroup$dFoldable.traverse1_(Data$dArray$dNonEmpty$dInternal.foldable1NonEmptyArray)(Data$dEither.applyEither);
  return b => a => $0(a)(b);
})();
const validateAvailability = catalogue => v => productKey => {
  const $0 = v.locale;
  const parameterChoiceUnavailable = (parameter, choice) => Data$dEither.$Either(
    "Left",
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.menu.availabilityValidation.parameterChoiceUnavailable),
      {
        parameterName: Restaumatic$dI18n$dTypes.getLocalization($0)(Data$dRecord.unsafeGet("name")(parameter)),
        choiceName: Restaumatic$dI18n$dTypes.getLocalization($0)(Data$dRecord.unsafeGet("name")(choice))
      }
    )
  );
  const modifierItemUnavailable = (_modifier, item) => Data$dEither.$Either(
    "Left",
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.menu.availabilityValidation.modifierItemUnavailable),
      {itemName: Restaumatic$dI18n$dTypes.getLocalization($0)(Data$dRecord.unsafeGet("name")(item))}
    )
  );
  const processPartLike = (parentParameterValues, part) => {
    const parameterValues = Data$dMap$dInternal.unsafeUnionWith(
      Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId.compare,
      Data$dFunction.const,
      parentParameterValues,
      Restaumatic$dMenu$dV2$dCartToOrder.fromCustomParameterValues(part.customParameters)
    );
    return Data$dEither.bindEither.bind(forWithIndex_(part.customParameters)(parameterId => parameterChoiceId => for_1((() => {
      const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(parameterId)(Data$dRecord.unsafeGet("customParameters")(catalogue));
      if ($1.tag === "Just") {
        const $2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(parameterChoiceId)(Data$dRecord.unsafeGet("choices")($1._1)._1);
        if ($2.tag === "Just") { return Data$dMaybe.$Maybe("Just", {parameter: $1._1, choice: $2._1}); }
        if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      }
      if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })())(v1 => {
      const $1 = v1.choice;
      const $2 = v1.parameter;
      return Data$dEither.bindEither.bind((() => {
        const $3 = Data$dRecord.unsafeGet("availability")($1).tag === "Available";
        const $4 = parameterChoiceUnavailable($2, $1);
        if (!$3) { return $4; }
        if ($3) { return Data$dEither.$Either("Right", undefined); }
        $runtime.fail();
      })())(() => {
        const $3 = Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("availableWhen")($1))(parameterValues);
        const $4 = parameterChoiceUnavailable($2, $1);
        if (!$3) { return $4; }
        if ($3) { return Data$dEither.$Either("Right", undefined); }
        $runtime.fail();
      });
    })))(() => Data$dEither.bindEither.bind(forWithIndex_(part.modifiers)(modifierId => choices => for_1(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(Data$dRecord.unsafeGet("modifiers")(catalogue)))(modifier => {
      const items = Restaumatic$dMenu$dV2$dMenuCatalogue.fold(Data$dFunctor.arrayMap(x => x.items)(Data$dRecord.unsafeGet("sections")(modifier)));
      return for_2(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr, Data$dMap.keys(choices)))(itemId => for_1(Data$dMap$dInternal.lookup(Data$dOrd.ordString)(itemId)(items._1))(item => Data$dEither.bindEither.bind((() => {
        const $1 = Data$dRecord.unsafeGet("availability")(item).tag === "Available";
        const $2 = modifierItemUnavailable(modifier, item);
        if (!$1) { return $2; }
        if ($1) { return Data$dEither.$Either("Right", undefined); }
        $runtime.fail();
      })())(() => {
        const $1 = Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("availableWhen")(item))(parameterValues);
        const $2 = modifierItemUnavailable(modifier, item);
        if (!$1) { return $2; }
        if ($1) { return Data$dEither.$Either("Right", undefined); }
        $runtime.fail();
      })));
    })))(() => Data$dEither.$Either("Right", parameterValues)));
  };
  return Data$dEither.bindEither.bind(processPartLike(
    Restaumatic$dMenu$dV2$dCartToOrder.fromInternalParameterValues(fold([
      v.params,
      Data$dMap$dInternal.$$$Map(
        "Node",
        1,
        1,
        Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.IsDivided,
        Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("IsDividedChoice", Data$dRecord.unsafeGet("parts")(productKey).length > 1),
        Data$dMap$dInternal.Leaf,
        Data$dMap$dInternal.Leaf
      )
    ])),
    productKey
  ))(toplevelParameterValues => for1_(Data$dRecord.unsafeGet("parts")(productKey))(part => {
    const $1 = processPartLike(toplevelParameterValues, part);
    if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
    if ($1.tag === "Right") { return Data$dEither.$Either("Right", undefined); }
    $runtime.fail();
  }));
};
export {fold, for1_, forWithIndex_, for_, for_1, for_2, validateAvailability};
